class SelectEmailTemplateController {
    constructor(Alert, $http, $scope, Templates, $uibModalInstance, $sce, showAttachInvoiceSelector, contact) {
        this.alert = Alert;
        this.api = $http;
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.sce = $sce;
        this.showAttachInvoiceSelector = showAttachInvoiceSelector;
        this.contact = contact;
        this.setTemplateConfig(Templates, $scope);
        this.selectedTemplateId = -1;
        this.template = null;

        this.data = {
            template: null,
            attach_invoice: true,
            send_to_override: this.contact ? this.contact.preferred_email : ''
        };

        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.contact;
        }, () => {
            if(this.contact) {
                this.setSendToOptions();
            }
        })
    }

    trustTemplateHtml(string) {
        return this.sce.trustAsHtml(string);
    }

    setTemplateConfig(Templates, $scope) {
        this.templatesConfig = {
            store: Templates.reset({persist: false}),
        };

        $scope.$watch(() => this.selectedTemplateId, id => {
            if (id && id > 0) {
                this.loading = true;
                this.api.get(`templates/${id}`)
                    .then(response => {
                        this.template = response.data.data;
                    }, response => this.alert.handle(response))
                    .finally(() => {
                        this.loading = false;
                    });
            }
        });
    }

    setSendToOptions() {
        this.emails = {};
        if (this.contact.email) {
            this.emails.private = this.contact.email
        }
        if (this.contact.business_email) {
            this.emails.business = this.contact.business_email
        }
        this.emails.custom = '';
        this.send_to_override = this.contact.business_preferred ? 'business' : 'private';
    }

    selectTemplate() {
        const dataToReturn = _.cloneDeep(this.data);
        dataToReturn.template = this.template;

        this.modalInstance.close(dataToReturn);
    }

    close() {
        this.modalInstance.dismiss();
    }
}

SelectEmailTemplateController.$inject = [
    'Alert',
    '$http',
    '$scope',
    'Templates',
    '$uibModalInstance',
    '$sce',
    'showAttachInvoiceSelector',
    'contact'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesCancelModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .controller('SelectEmailTemplateCtrl', SelectEmailTemplateController);



// WEBPACK FOOTER //
// ./src/app/components/services/resourcecommon/controllers/select-email-template-controller.js